module.exports = __webpack_public_path__ + "media/images/element/create-account-fca8b12ba9016935ebfd886413280c8e.svg";